if ($('#area_table').length) {


    //creo que es mas facil colocar el ulitmo de get
    let url = window.location.origin + '/picking-areas/get';
    let urlRuta = 'picking-areas';
    let urlRuta2 = 'picking-areas-details';
    let formName = '#formArea';
    let modalName = '#modal-area';
    let tableName = '#area_table';

    setTimeout(function () {
        areas_table();
    }, 500);


    function areas_table() {

        $(tableName).dataTable({
            "processing": true,
            "serverSide": true,
            "ajax": url,
            "columns": [
                {data: 'codigo'},
                {data: 'descripcion'},
                {data: 'status'},

            ],
            //"order": [[1, 'desc']],
            "columnDefs": [
                //{ targets: 0, width: '30%' },
                {
                    "targets": 2,
                    "render": function (data, type, row, meta) {
                        if (row.status === Status.ACTIVO) {
                            return "<span class='badge badge-success'><big>Activo</big></span>";
                        } else {
                            return "<span class='badge badge-danger'><big>Inactivo</big></span>";
                        }
                    }
                },
                {
                    "targets": 3,
                    "render": function (data, type, row, meta) {

                        if (row.status !== 'Eliminado') {
                            return "<button type='button' class='btn btn-primary btn-sm edit' data-customer='" + row + "' data-bs-toggle='tooltip' title='Editar Área'><i class='fas fa-pencil-alt'></i></button> " +
                                "<button type='button' class='btn btn-primary btn-sm add' data-customer='" + row + "' data-bs-toggle='tooltip' title='Detalle Área'><i class='fas fa-clipboard-list'></i></button> "
                                + "<button type='button' class='btn btn-danger btn-sm remove' data-customer='" + row + "' data-bs-toggle='tooltip' title='Eliminar Área'><i class='fas fa-trash'></i></button> ";
                        } else {
                            return "<button type='button' class='btn btn-success btn-sm activate' data-id='" + row.id + "' data-bs-toggle='tooltip' title='Reactivar Área'><i class='fa fa-check'></i></button> ";
                        }
                    }
                },

            ],
            "language": {
                "url": window.location.origin + "/json/Spanish.json"
            },
        });

        $(tableName).on('draw.dt', function () {
            $('[data-bs-toggle="tooltip"]').tooltip();
        });

        $(tableName + ' tbody').on('click', '.edit', function (e) {
            e.preventDefault();
            let table = $(tableName).DataTable();
            let rowData = table.row($(this).parents('tr')).data();

            $.ajax({
                url: window.location.origin + '/' + urlRuta + '/' + rowData.id + '/edit',
                type: 'GET',
            })
                .done(function (response) {
                    document.getElementById('div_modal').innerHTML = response;
                    $('.chosen-select').chosen({width: '100%'});
                    $('#modal-area').modal("show");

                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });
        });

        $(tableName + ' tbody').on('click', '.add', function (e) {
            e.preventDefault();
            let table = $(tableName).DataTable();
            let rowData = table.row($(this).parents('tr')).data();
            addAreaDetail(rowData.id, rowData.descripcion);
        });

        $(tableName + ' tbody').on('click', '.remove', function (e) {
            e.preventDefault();
            let table = $(tableName).DataTable();
            let rowData = table.row($(this).parents('tr')).data();
            Swal
                .fire({
                    title: "Eliminar área  " + rowData.codigo,
                    text: "¿Eliminar?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: "Sí, eliminar",
                    cancelButtonText: "Cancelar",
                })
                .then(resultado => {
                    if (resultado.value) {
                        let url = window.location.origin + '/' + urlRuta + '/' + rowData.id;
                        $.ajax({
                            url: url,
                            type: 'DELETE',
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            }
                        })
                            .done(function (response) {
                                Swal.fire('Eliminado', 'Se ha eliminado el área.', 'success')
                                    .then(() => {

                                        let url = window.location.origin + '/' + urlRuta + '/get';
                                        $(tableName).DataTable().ajax.url(url).load();

                                        //const table = $('#orders_table').DataTable();
                                        //table.ajax.reload(() => table.page(table.page()).draw('page'));

                                    });
                            })
                            .fail(function (jqXHR, textStatus) {
                                console.log(jqXHR);
                                alert("Disculpe, existió un problema");
                            });
                    }
                });
        });

    }

    $(".add_area").on('click', function () {

        $.ajax({
            url: window.location.origin + '/' + urlRuta + '/create',
            type: 'GET',
        })
            .done(function (response) {
                document.getElementById('div_modal').innerHTML = response;
                $(modalName).modal("show");
                $('.chosen-select').chosen({width: '100%'});

            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });

    })

    $(document).on('click', '#btn_cancel', function (event) {

        let areaId = $('#area_surtido_id').val();
        let descripcion = $('#descripcion').val();

        $('#modal-area').modal("hide");
        $('#modal-area-detail').modal("hide");

        setTimeout(function () {
            addAreaDetail(areaId, descripcion);
        }, 400);

    })


    $(document).on('click', '#btn_save', function (event) {
        event.preventDefault();

        let url = window.location.origin + '/' + urlRuta;
        let formData = new FormData($(formName)[0]);

        document.getElementById('div_message').innerHTML = "";
        $.ajax({
            data: formData,
            url: url,
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {
                if (response.success) {
                    Swal.fire('Agregado', response.message, 'success')
                        .then(() => {
                            $(modalName).modal("hide");
                            let url = window.location.origin + '/' + urlRuta + '/get';
                            $(tableName).DataTable().ajax.url(url).load();

                            /*if (response.order_id !== 0) {
                                setTimeout(function () {
                                    loadOrderItemsModal(response.order_id);
                                }, 500);
                            }*/

                        });
                } else {
                    Swal.fire('Error', response.message, 'error');
                }
            })
            .fail(function (jqXHR, textStatus) {
                //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                if (jqXHR['status'] == 422) {

                    let errors = "<ul class=''>";
                    let items = "";

                    $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                        items = items + "<li class=''>" + value + "</li>";
                    });

                    errors = errors + items + "</ul>";
                    let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                        + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                        + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                        + errors
                        + "</div></div></div>";
                    document.getElementById('div_message').innerHTML = view;
                } else {
                    console.log(jqXHR['status']);
                    alert("Disculpe, existió un problema");
                }
            });
    });

    $(document).on('click', '#btn_save_2', function (event) {
        event.preventDefault();

        let url = window.location.origin + '/' + urlRuta2;
        let formData = new FormData($(formName)[0]);
        formData.append('area_surtido_id', $('#area_surtido_id').val());

        document.getElementById('div_message').innerHTML = "";
        $.ajax({
            data: formData,
            url: url,
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {
                if (response.success) {

                    let areaId = $('#area_surtido_id').val();
                    let descripcion = $('#descripcion').val();

                    $('#modal-area').modal("hide");
                    $('#modal-area-detail').modal("hide");
                    Swal.fire('Agregado', response.message, 'success')
                        .then(() => {

                            addAreaDetail(areaId, descripcion);
                        });
                } else {
                    Swal.fire('Error', response.message, 'error');
                }
            })
            .fail(function (jqXHR, textStatus) {
                //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                if (jqXHR['status'] == 422) {

                    let errors = "<ul class=''>";
                    let items = "";

                    $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                        items = items + "<li class=''>" + value + "</li>";
                    });

                    errors = errors + items + "</ul>";
                    let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                        + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                        + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                        + errors
                        + "</div></div></div>";
                    document.getElementById('div_message').innerHTML = view;
                } else {
                    console.log(jqXHR['status']);
                    alert("Disculpe, existió un problema");
                }
            });
    });


    $(document).on('click', '#btn_update', function (event) {

        event.preventDefault();
        let id = $("#id").val();
        let url = window.location.origin + '/' + urlRuta + '/' + id;

        let formData = new FormData($(formName)[0]);
        formData.append('_method', 'PUT');

        document.getElementById('div_message').innerHTML = "";
        $.ajax({
            data: formData,
            url: url,
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {

                if (typeof response['status'] !== 'undefined') {
                    Swal.fire('Advertencia', response['message'], 'info')
                        .then(() => {
                            location.reload();
                        });
                } else {
                    Swal.fire('Actualizado', 'Se actualizo el pedido correctamente', 'success')
                        .then(() => {
                            $('#modal-area').modal("hide");
                            let url = window.location.origin + '/picking-areas/get';
                            $(tableName).DataTable().ajax.url(url).load();
                        });
                }

            })
            .fail(function (jqXHR, textStatus) {
                //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                if (jqXHR['status'] == 422) {

                    let errors = "<ul class=''>";
                    let items = "";

                    $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                        items = items + "<li class=''>" + value + "</li>";
                    });

                    errors = errors + items + "</ul>";
                    let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                        + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                        + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                        + errors
                        + "</div></div></div>";
                    document.getElementById('div_message').innerHTML = view;
                } else {
                    console.log(jqXHR['status']);
                    alert("Disculpe, existió un problema");
                }
            });
    });


    $(document).on('click', '#btn_update_2', function (event) {

        event.preventDefault();
        let id = $("#id").val();
        let url = window.location.origin + '/area-surtido-detalles/' + id;

        let formData = new FormData($('#formAreaDetail')[0]);
        formData.append('area_surtido_id', $('#area_surtido_id').val());
        formData.append('_method', 'PUT');

        document.getElementById('div_message').innerHTML = "";
        $.ajax({
            data: formData,
            url: url,
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {

                if (typeof response['status'] !== 'undefined') {
                    Swal.fire('Advertencia', response['message'], 'info')
                        .then(() => {
                            location.reload();
                        });
                } else {
                    let areaId = $('#area_surtido_id').val();
                    let descripcion = $('#descripcion').val();

                    $('#modal-area').modal("hide");
                    $('#modal-area-detail').modal("hide");

                    Swal.fire('Actualizado', 'Se actualizo el pedido correctamente', 'success')
                        .then(() => {
                            addAreaDetail(areaId, descripcion);
                        });
                }

            })
            .fail(function (jqXHR, textStatus) {
                //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                if (jqXHR['status'] == 422) {

                    let errors = "<ul class=''>";
                    let items = "";

                    $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                        items = items + "<li class=''>" + value + "</li>";
                    });

                    errors = errors + items + "</ul>";
                    let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                        + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                        + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                        + errors
                        + "</div></div></div>";
                    document.getElementById('div_message').innerHTML = view;
                } else {
                    console.log(jqXHR['status']);
                    alert("Disculpe, existió un problema");
                }
            });
    });


    function addAreaDetail(id, descripcion) {
        $.ajax({
            url: window.location.origin + '/picking-areas-details/get/' + id + '/' + descripcion,
            type: 'GET',
        })
            .done(function (response) {
                $('#div_modal').html(response);
                $('.chosen-select').chosen({width: '100%'});
                $('#modal-area').modal("show");

                $('#area_detail_table').DataTable({
                    language: {
                        url: window.location.origin + "/json/Spanish.json"
                    }
                });
            })
            .fail(function (jqXHR) {
                console.error(jqXHR);
                alert("Disculpe, existió un problema");
            });
    }


    window.nuevoDetalle = function (id) {
        $.ajax({
            url: window.location.origin + '/picking-areas-details-save' + '/' + id,
            type: 'GET',
        })
            .done(function (response) {
                document.getElementById('div_modal_2').innerHTML = response;
                $('.chosen-select').chosen({width: '100%'});
                $('#modal-area-detail').modal("show");
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });
    };

    window.editarArea = function (id) {
        $.ajax({
            url: window.location.origin + '/area-surtido-detalles/' + id + '/edit',
            type: 'GET',
        })
            .done(function (response) {
                document.getElementById('div_modal_2').innerHTML = response;
                $('.chosen-select').chosen({width: '100%'});
                $('#modal-area-detail').modal("show");

            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });
    };

    window.eliminarArea = function (id) {
        if (confirm("¿Seguro que quieres eliminar este detalle?")) {

            let url = window.location.origin + '/area-surtido-detalles/' + id;

            $.ajax({
                url: url,
                type: 'DELETE',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {

                    let areaId = $('#area_surtido_id').val();
                    let descripcion = $('#descripcion').val();

                    $('#modal-area').modal("hide");
                    $('#modal-area-detail').modal("hide");

                    Swal.fire('Eliminado', 'Se ha eliminado el área.', 'success')
                        .then(() => {
                            addAreaDetail(areaId, descripcion);
                        });
                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });
        }
    };


}





